<div class="ao-list-item flexbox">
	<p>{{ activityStatus.date | date: 'MM/dd/yyyy' }}</p>
	<div class="status-details">
		<p [innerHTML]="activityStatus.description"></p>
		<p [innerHTML]="activityStatus.additionalDetails" class="ao-top-16"></p>
	</div>
</div>
